import type { LinkedinCookies } from '@shared/schemas';

import api from '@/shared/api/api-client';

import type { LinkedinCookiesGateway } from './linkedin-cookies.gateway';

/** Real implementation over the shared api client; the account cookie endpoints. */
export const httpLinkedinCookiesGateway: LinkedinCookiesGateway = {
  load: () => api.get<LinkedinCookies>('/account/linkedin-cookies'),
  save: (input) => api.patch<LinkedinCookies>('/account/linkedin-cookies', input),
};
